import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID } from './get-document-importer-template-by-id.hook';
import { GET_DOCUMENT_IMPORTER_TEMPLATES } from './get-document-importer-templates.hook';


export const UPDATE_DOCUMENT_IMPORTER_TEMPLATE = gql`
  mutation updateDocumentImporterTemplate($payload: UpdateDocumentImporterTemplateInput!) {
    updateDocumentImporterTemplate(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateDocumentImporterTemplate = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('settings');
  const [updateDocumentImporterTemplate, { loading }] = useMutation(UPDATE_DOCUMENT_IMPORTER_TEMPLATE, {
    onCompleted: data => {
      if (data?.updateDocumentImporterTemplate?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('documentImporter.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [
      GET_DOCUMENT_IMPORTER_TEMPLATE_BY_ID,
      GET_DOCUMENT_IMPORTER_TEMPLATES
  ]});

  return { updateDocumentImporterTemplate, loading };
};
